import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { toCamel } from 'convert-keys';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Timezone } from 'src/app/shared/model/timezone.model';
import { GenericOldService } from './generic-old.service';

@Injectable()
export class TimezoneService {
  private timezones$: Observable<Timezone[]>;
  private _timezones: Timezone[];

  get timezones(): Timezone[] {
    return this._timezones;
  }

  constructor(private resourceService: GenericOldService<Timezone[]>) {}

  getTimezones(): Observable<Timezone[]> {
    if (!this.timezones$ && !this._timezones) {
      this.timezones$ = this.resourceService.get(`reference/timezones`).pipe(
        map(item => {
          this._timezones = toCamel<Timezone[]>(item);
          return this._timezones;
        }),
        shareReplay(1),
      );
    }
    return this.timezones$;
  }
}
